import { render, staticRenderFns } from "./listGamification.vue?vue&type=template&id=7fcc5ac8&scoped=true"
import script from "./listGamification.vue?vue&type=script&lang=js"
export * from "./listGamification.vue?vue&type=script&lang=js"
import style0 from "./listGamification.vue?vue&type=style&index=0&id=7fcc5ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcc5ac8",
  null
  
)

export default component.exports